import React from 'react';

interface WordmarkProps {
  /** In-app navigation handler; when given, the default full-page link is suppressed. */
  onNavigate?: () => void;
  /** Override the 24px default, e.g. on the login card. */
  fontSize?: number;
}

/**
 * The "underwritRE" text wordmark from underwritre.com.
 * Styling lives in the `.wordmark` class in theme.ts (globalStyles).
 */
export const Wordmark: React.FC<WordmarkProps> = ({ onNavigate, fontSize }) => (
  <a
    href="/"
    className="wordmark"
    aria-label="UnderwritRE home"
    style={fontSize ? { fontSize } : undefined}
    onClick={
      onNavigate
        ? (e) => {
            e.preventDefault();
            onNavigate();
          }
        : undefined
    }
  >
    underwrit<span>RE</span>
  </a>
);
